import { render, staticRenderFns } from "./IcoPlusSquare.vue?vue&type=template&id=56468cdc"
import script from "./IcoPlusSquare.vue?vue&type=script&lang=js"
export * from "./IcoPlusSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports